export default {
  plural: 'Rules',
  materialRules: 'Material rules',
  attachmentRules: 'Attachment rules',
  socketAcceptances: 'Socket acceptances',
  fields: {
    code: 'Code',
    meshPattern: 'Mesh pattern',
    materialPattern: 'Material pattern',
    hostPattern: 'Host pattern',
    partPattern: 'Part pattern',
    matchType: 'Match type',
    mateRotationDeg: 'Mate rotation (°)',
    mirrorOnMate: 'Mirror on mate',
    nodeId: 'Node ID',
    socketPattern: 'Socket pattern',
    mode: 'Mode'
  },
  matchType: {
    prefix: 'Prefix',
    exact: 'Exact'
  },
  acceptanceMode: {
    acceptByRule: 'Accept by rule',
    curatedOnly: 'Curated only'
  },
  scope: {
    label: 'Scope',
    global: 'Global',
    company: 'Company',
    configurator: 'Configurator'
  },
  addRow: 'Add row',
  save: 'Save',
  unsavedChanges: 'Unsaved changes',
  override: 'Override',
  inheritedFrom: 'Inherited from {{origin}}',
  noRules: 'No rules yet',
  selectCompany: 'Select a company',
  materialRulesInactiveBanner:
    "Material rules don't affect the widget right now — zone materials are controlled through the zone template's allowed materials (verified 2026-08-14).",
  contextual: {
    inheritedTitle: 'Inherited rules',
    localTitle: 'Local rules (this configurator)',
    levelGlobal: 'Global',
    levelCompany: 'Company',
    editOnRulesPage: 'Edit on the rules page',
    noInherited: 'No inherited rules apply',
    noLocal: 'No local rules yet',
    addAttachmentRule: 'Add attachment rule',
    materialsPointer: 'Zone materials are managed in the',
    materialRuleInactive: 'inactive',
    hostSocket: 'Host socket',
    connector: 'Connector',
    connectorSelectsParts: 'Selects parts:',
    socketRulesTitle: 'Rules for this socket',
    socketRulesHint:
      'Which connectors may attach here. Global and company rules are read-only.',
    zoneRulesTitle: 'Rules for this zone',
    zoneRulesHint:
      'Material rules referencing this zone. They have no effect on the widget yet.',
    allowConnector: 'Allow connector',
    levelLocal: 'Local',
    alreadyAllowed: 'already allowed',
    noSocketRules: 'No rules apply to this socket',
    advanced: 'Advanced',
    save: 'Save rule',
    cancel: 'Cancel',
    close: 'Close',
    remove: 'Remove',
    preview: {
      title: 'Live preview',
      noViewer:
        'No published viewer yet — the widget has nothing to resolve against',
      noTargets:
        'This hostPattern covers no socket in the current default variant — the rule would go nowhere',
      noPartsYet: 'Socket matched — no parts currently resolve here.',
      nested: 'nested',
      curatedOnlyHint:
        'Rule-based candidates are hidden here until this socket is switched to accept-by-rule',
      savedRefreshed:
        'Rule saved — candidates below are after the viewer reload'
    }
  }
};
